import path from 'path';

export function getPathTemplates(template: string) {
  if (process.env.NODE_ENV === 'dev') {
    return path.resolve(process.cwd(), 'views', template);
  }

  return path.resolve(__dirname, template);
}
